// Config đa môi trường: main, staging, production
const ENV_CONFIG = {
  main: "https://clinic.medeco.vn/api/v2",
  staging: "https://clinic-staging.medeco.vn/api/v2",
  production: "https://clinic.medeco.vn/api/v2",
};

// Ưu tiên lấy từ biến môi trường REACT_APP_ENV, fallback NODE_ENV, mặc định là 'main'
const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || "main";

export const BASE_URL = ENV_CONFIG[ENV] || ENV_CONFIG.main;
